import { gql } from 'apollo-boost';

export const GET_SYSTEM_BUSINESS = gql`
query SystemBusiness{
  system_business{
    id
  }
}
`;
